import { defineMessages } from "react-intl";

export default defineMessages({
  priceFrom: {
    id: 'priceFrom',
    defaultMessage: 'Price from:'
  }
});